import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IDwelling, IDwellingInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class DwellingApiService {
  abstract getDwellingList(): Observable<IDwelling[]>;
  abstract getWithdrawnDwellingList(): Observable<IDwelling[]>;
  abstract getDwelling(id: string): Observable<IDwelling>;
  abstract withdrawDwelling(
    dwellingInput: IDwellingInput,
    dwellingId: string
  ): Observable<any>;
}
